export default __webpack_public_path__ + "05d44b92d40e2aec6eed57a57411e5fe.png";